/**
 * 线上环境
 */
export const ONLINEHOST_EMOF = 'https://www.emof.cn/index.php/' //益魔方上线正式
export const YHB_URL = 'https://yhb.emof.cn' // 益会宝上线正式

export const ONLINEHOST = 'https://hygl.emof.cn/index.php/' //上线正式

/**
 * 测试环境
 */
// export const QAHOST = 'http://192.168.2.143:8115/'
// export const QAHOST = 'http://192.168.1.23:8115/index.php/'
export const QAHOST = 'https://hygl.emof.cn/index.php/' // 益魔方域名

export const HOSTPATH = 'https://hygl.emof.cn/vw/' // 益魔方域名
export const MOBILE_HOSTPATH = 'https://hygl.emof.cn/mobile/' // 益魔方手机域名

export const baseURL = process.env.NODE_ENV === 'production' ? ONLINEHOST : QAHOST

//文件地址
export const IMAGE_PATH = baseURL.replace('index.php/','')

export const filePath = 'https://img.emof.cn'
//文件上传地址
export const fileUpUrl = 'https://upload-z2.qiniup.com/'
/*
* 缓存字段
* */
export const localAnStore = [
    {
        key: 'o_mid',
        type: 'localStorage'
    },
    {
        key: 'user',
        type: 'localStorage'
    },
    {
        key: 'cookie_user',
        type: 'cookie',
        day: 365,
        path: '/',
    },
    {
        key: 'userAll',
        type: 'localStorage'
    },
    {
        key: 'emofUserTokenSafer',
        type: 'cookie',
        day: 365,
        path: '/',
    }
]
